module.exports = __webpack_public_path__ + "static/13.509c700b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/organizacja/13.jpg
// module id = 664
// module chunks = 65182145508788